import { render } from "./CustomerEdit.vue?vue&type=template&id=50d4e65c&scoped=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=js"
export * from "./CustomerEdit.vue?vue&type=script&lang=js"

import "./CustomerEdit.vue?vue&type=style&index=0&id=50d4e65c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50d4e65c"

export default script